import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Products } from "../../../../../../listing/components/list";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { action_fetch_order_ofteh_bought_with } from "../../../../../../../../store/actions/pages/customer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export default props =>{
    useStyles(cls);
    const { orderId, title } = props;
    const dispatch = useDispatch();
    const pageCustomer = useSelector(state =>state.pageCustomer);
    const { orderOftenList } = pageCustomer;
    const Intl = useIntl();

    useEffect(async () =>{
        if(!orderOftenList || orderOftenList?.length <= 0){
            dispatch(action_fetch_order_ofteh_bought_with(orderId));
        }
    }, [orderOftenList]);

    return <div className={cls.OrderRecommend}>
        <div className={cls.Hd}>{title || Intl.formatMessage({ id: "often_bought_with", defaultMessage: "OFTEN BOUGHT WITH" })}</div>

        <div className={cls.Bd}>
            <Products 
                products={orderOftenList} 
                ingoreCard
            />
        </div>

        {
            (!orderOftenList || orderOftenList <= 0) && <div className={cls.Loading}><FormattedMessage id="loading" defaultMessage="Loading" /></div>
        }
    </div>
}